<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous réactiver l'utilisateur <strong>{{user.nom}} {{user.prenom}} </strong> - <strong>{{user.arrondissement_id | allArrondissementName}}</strong> ?
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Réactiver
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'user',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('reactivateUser', this.user)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// UserReactivate.vue?498d8840